import { render, staticRenderFns } from "./DropdownProfileSelector.vue?vue&type=template&id=5d6099b0&scoped=true&"
import script from "./DropdownProfileSelector.vue?vue&type=script&lang=js&"
export * from "./DropdownProfileSelector.vue?vue&type=script&lang=js&"
import style0 from "./DropdownProfileSelector.vue?vue&type=style&index=0&id=5d6099b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6099b0",
  null
  
)

export default component.exports